import React, { useEffect, useState } from 'react';
import { DownloadFile } from './Function';
import { Card,Table,Placeholder,Button } from 'react-bootstrap';
const FormsEstablishment = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Forms,setForms]=useState([]);
    useEffect(()=>
    {
        const FormsAll = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"forms/all");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sf_id + "/formPdf")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sf_id + "/formPdfHi")
                                .then(upph => upph.json());
                            const fetch3 = fetch(global.config.API_URL + "upload/details/0/" + e.sf_id + "/formDoc")
                                .then(upd => upd.json());
                            const fetch4 = fetch(global.config.API_URL + "upload/details/0/" + e.sf_id + "/formDocHi")
                                .then(updh => updh.json());
                            return Promise.all([fetch1, fetch2, fetch3, fetch4])
                                .then(([upp,upph,upd,updh]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph,
                                        upd,
                                        updh
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].formPdf = el.upp;
                            result[i].formPdfHi = el.upph;
                            result[i].formDoc = el.upd;
                            result[i].formDocHi = el.updh;
                        });
                        setForms(result);
                        setLoading(false);
                    }).catch(error => 
                    {
                        console.error('FormsAll File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setForms([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('FormsAll : Result',result); }
            }
            catch (error) 
            {
                console.error('FormsAll : Error', error.message);
            }
        };
        FormsAll();
    },[])  
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-uppercase text-center fs-3' data-aos="flip-up" data-aos-duration="1500">
                {appLanguage === 'hi' ? 'औपचारिक प्रपत्र' : 'FORMS FOR ESTABLISHMENT'}
            </Card.Header>
            <Card.Body>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                    <tr>
                        <th className="w-50">{appLanguage === 'hi' ? 'शीर्षक' : 'Title'}</th>
                        <th>{appLanguage === 'hi' ? 'डाउनलोड' : 'Download'}</th>
                    </tr>
                    </thead>
                    
                    {isLoading ? ( 
                    <tbody>                       
                        {[...Array(10)].map((_,index) => (
                            <tr key={index}> 
                                <th className="table-success"><Placeholder xs={10} bg="success" /></th>
                                <td className="text-center"><Button className="btn btn-light w-100"><Placeholder xs={10} bg="dark" /></Button></td>
                            </tr>
                        ))}
                    </tbody>
                    ) : (
                    <tbody>
                        {Forms.map((sf,index)=>(
                            <tr key={index}>
                                <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (sf.sf_display_en === "1" ? sf.sf_name_hi || '' : sf.sf_name_hi || sf.sf_name) : sf.sf_name}}></th>
                                <td className="text-center">
                                    <span className='mx-1' dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sf.formPdf,sf.formPdfHi)}} />
                                    <span className='mx-1' dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sf.formDoc,sf.formDocHi)}} />                                    
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    )}
                </Table>
            </Card.Body>
        </Card>
    ); 
}
export default FormsEstablishment;